<div class="customHeader">
  <img src="/assets/Logo-H.png" height="50px">
</div>
<div>
  <router-outlet></router-outlet>
</div>
